"use client";

import { useMemo } from "react";
import type { SelectedThought, Target } from "@/generated/fastapi";
import useStudioArrangementState from "./useStudioArrangementState";

export default function useStudioSituationArrangement({
  selectedThoughts,
  rerankTarget,
  scopeKey,
}: {
  selectedThoughts: SelectedThought[];
  rerankTarget?: Target | null | undefined;
  scopeKey: string;
}) {
  const sourceKeyPayload = useMemo(
    () => ({
      selectedThoughts: selectedThoughts.map((selection) => ({
        prototype: selection.prototype,
        situation_id: selection.situation_id,
        thoughts_ids: selection.thoughts_ids,
      })),
    }),
    [selectedThoughts],
  );

  return useStudioArrangementState({
    selectedThoughts,
    rerankTarget,
    scopeKey,
    sourceKeyPayload,
  });
}
